import React, { useState, useEffect  } from "react";
import {useDispatch} from 'react-redux'
import { Card, Form, Input, Button, Checkbox, Typography, theme, notification } from "antd";
import {
  UserOutlined, LockOutlined, UnlockOutlined, LoadingOutlined
} from "@ant-design/icons";
import { useNavigate } from 'react-router-dom';
import Logo from "../../../assets/logo/logo.svg";
import Limage from "../../../assets/bill.svg";
import validateForm from '../../../utils/FormValidation';
import validationRules from '../../../assets/validation/rules';
import { loginStart, loginSuccess, loginFailure } from '../../../redux/slices/authSlice';
import AuthRestAPI from '../../../restAPI/AuthRestAPI';
import { decodeToken } from "react-jwt";
import { AESEncryption, AESDecryption} from "../../../utils/Aes";

const { Title } = Typography;

const MoguLogin = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false); // State to manage loading icon
  const [payload, setPayload] = useState({
    username: "",
    password: "",
  });
  const [errors, setErrors] = useState({});
  const [currentValidation, setCurrentValidation] = useState('');
  const [hasNotificationShown, setHasNotificationShown] = useState(false);
  const [isRememberMe, setIsRememberMe] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const handleNavigateToLogin = () => {
    navigate('/resetpassword');
  };
  const onFinish = (values) => {
  };
  const {
    token: { colorTextQuaternary },
  } = theme.useToken();

  const onFinishFailed = (errorInfo) => {
  };

   useEffect(() => {
      if(localStorage.getItem('username') !== null && localStorage.getItem('password') !== null){
        setPayload({
          "username": AESDecryption(localStorage.getItem('username')),
          "password": AESDecryption(localStorage.getItem('password'))
        });
      } 
    },[]);

  const handleLogin = async () => {
    setIsButtonDisabled(true);
    //validate data
    const validateData = {
      username: payload.username,
     // loginPassword: payload.password
     loginPasswordWhenLogin : payload.password
    }
    //get validate result
    const validationResult = validateForm(validateData, validationRules)
    if (!validationResult.isValid) {
      const err = validationResult.errors
      const newErrors = {};
      const firstErrorMessage = Object.values(err)[0];

      Object.keys(err).forEach((value) => {
        newErrors[value] = err[value];
      })

      setErrors(newErrors);
      setCurrentValidation(firstErrorMessage);

      if (!hasNotificationShown || currentValidation !== firstErrorMessage) {
        //openNotificationWithIcon('error', "Validation", Object.values(err)[0], 'topRight');
        setHasNotificationShown(false);
      }
      setIsButtonDisabled(false);
    }else{
      setCurrentValidation('');
      setHasNotificationShown(false);
      dispatch(loginStart());
      setLoading(true); // Start loading animation
      
      if(isRememberMe){
        localStorage.setItem('username', AESEncryption(payload["username"]));
        localStorage.setItem('password', AESEncryption(payload["password"]));
      }

      AuthRestAPI.login(payload).then((res) => {
        const decodedTokenValue = decodeToken(res.token);
        
        if(decodedTokenValue?.isFirstTime){
          setLoading(false);
          return dispatch(navigate("/firsttimeresetpassword/:tokenId?" + res.token));
        }
      
        // create payload
        const payload = {
          token: res.token,
          userId : decodedTokenValue.userId,
          firstName: decodedTokenValue.firstName,
          email: decodedTokenValue.email,
          role: decodedTokenValue.role
        }
        
        const encryptedToken = AESEncryption(res.token);
        //save in local storage
        localStorage.setItem('token', encryptedToken);

        dispatch(loginSuccess(payload));
        setLoading(false);
        openNotificationWithIcon('success', 'Login successful', `Welcome back!`, 'topRight');
        navigate("/dashboard");

      }).catch((err) => {
        if (err.response) {
          dispatch(loginFailure(err.response.data));
          //openNotificationWithIcon('error', 'Login failed', `${err.response.data.message}`, 'topRight');
          //setErrors({"loginPassword": err.response.data.message });
          setErrors({"loginPasswordWhenLogin": err.response.data.message });
          setTimeout(() => {
            setIsButtonDisabled(false);
          }, 6000);
        } else {
          dispatch(loginFailure(err.message));
          //openNotificationWithIcon('error', 'Login failed', `${err.message}`, 'topRight');
          //setErrors({"loginPassword": err.message });
          setErrors({"loginPasswordWhenLogin": err.message });
          setTimeout(() => {
            setIsButtonDisabled(false);
          }, 6000);
        }
      }).finally(() => {
        setLoading(false);
      })
    }
  };

  function validateFormData(data) {
    const validationResult = validateForm(data, validationRules)
    if (!validationResult.isValid) {
      const err = validationResult.errors
      const newErrors = {};
      Object.keys(err).forEach((value) => {
        newErrors[value] = err[value];
      })
      setErrors(prev => ({ ...prev, ...newErrors }));
    } else {
      const keyData = Object.keys(data)[0]
      setErrors(prev => ({ ...prev, [keyData]: '' }))
    }
  }

  const [api, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = (type, message, description, placement) => {
    api[type]({
      message: message,
      description: description,
      placement
    });
  };

  const onCheckChange = (e) => {
    setIsRememberMe(e.target.checked);
  }

  return (
    <div className="login-page">
      <div className="login-container">
        {/* Left Section */}
        <div className="left-section">
          {/* Decorative 3D shapes */}
          <div className="decorative-shape-1"></div>
          <div className="decorative-shape-2"></div>
          
          <center>
            <h1 style={{fontWeight:'400'}}>
              mogu <br />
              <span>e-Invoicing System</span>
            </h1>
            <br />
            <br />
            <img src={Limage} style={{ width: "50%" }} alt="Left Section" />
          </center>
        </div>

        {/* Right Section */}
        <div className="border-container right-section" style={{ width: "50%"}}>
          <Button
            type="primary"
            className="card-button"
            style={{ pointerEvents: "none" }}
            size="large"
            icon={<UserOutlined />}
            shape="circle"
          ></Button>
          <Card className="right-card">
            <div
              className="logo"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <center>
                <Title level={1} className="logotext login-logo" style={{ fontSize: '4rem' }}>
                  <span style={{ display: "flex", alignItems: "center" }}>
                    <img
                      style={{ width: 52, marginTop: -15 }}
                      src={Logo}
                      alt="Logo"
                    />{" "}
                    mogu
                  </span>
                </Title>
              </center>
            </div>
            <center>
              <h2>Welcome!</h2>
              <p className="subtitle">
                Please log in using your email address and password.
              </p>
            </center>
            <Form
              layout="vertical"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
            >
              <Form.Item validateStatus={errors.username ? 'error' : ''} help={errors.username || ''} required >

                <Input
                  size="large"
                  name="username"
                  placeholder="Username"
                  onChange={(e) => {
                    const validateData = {
                      username: e.target.value
                    }
                    validateFormData(validateData);
                    setPayload(prev => ({
                      ...prev,
                      username: e.target.value
                    }));
                  }}
                  value={payload["username"]}
                  prefix={<UserOutlined style={{color:colorTextQuaternary}} />}
                />
              </Form.Item>

              <Form.Item validateStatus={errors.loginPasswordWhenLogin ? 'error' : ''} help={errors.loginPasswordWhenLogin || ''} required >

                <Input.Password
                  size="large"
                  name="password"
                  placeholder="Password"
                  onChange={(e) => {

                    /*const validateData = {
                      loginPassword: e.target.value
                    }
                    validateFormData(validateData);*/
    
                    setPayload(prev => ({
                      ...prev,
                      password: e.target.value
                    }));
                  }}
                  value={payload["password"]}
                  prefix={<LockOutlined style={{color:colorTextQuaternary}} />}
                />
              </Form.Item>

              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Form.Item name="remember" valuePropName="checked" noStyle>
                  <Checkbox onChange={onCheckChange}>Remember me</Checkbox>
                </Form.Item>
                <Button type="link" onClick={handleNavigateToLogin} style={{padding:'0'}}>
                Forgot password?
                    </Button>
               
              </div>

              <Form.Item style={{marginTop:'24px'}}>
                <Button
                  type="primary"
                  size="large"
                  disabled={isButtonDisabled}
                  icon={loading ? <LoadingOutlined /> : <UnlockOutlined />}
                  onClick={handleLogin}
                  block
                  //disabled={loading} // Disable button while loading
                >
                  {loading ? "Logging in..." : "Login"}
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </div>
      </div>
      {contextHolder}
    </div>
  );
};

export default MoguLogin;
